import { z } from 'zod';
import { CursorPagination } from './common.js';
export const GroupSummary = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    tgChatId: z.string(),
    title: z.string(),
    joinedByAccountId: z.string().uuid().nullable(),
    joinedAt: z.string().datetime().nullable(),
    silentUntil: z.string().datetime().nullable(),
    /** 0..1 share of messages judged by the LLM cascade (1 = all). */
    judgeSampleRate: z.number().optional(),
    status: z.enum(['pending', 'active', 'left', 'kicked', 'readonly']),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ListGroupsQuery = CursorPagination.extend({
    status: z
        .enum(['pending', 'active', 'left', 'kicked', 'readonly'])
        .optional(),
});
export const AddGroupsRequest = z.object({
    /** Lines of group invite links or @usernames. */
    links: z.array(z.string().min(1)).min(1).max(100),
    /**
     * Account that should issue the join. MVP requires explicit selection;
     * auto-assignment by load can land later once we track per-account
     * join-rate budgets.
     */
    joinByAccountId: z.string().uuid(),
});
export const AddGroupsResponse = z.object({
    created: z.array(GroupSummary),
    /** Joins that TG accepted as "request sent, waiting for group-admin
     *  approval" (INVITE_REQUEST_SENT). Not a failure — once the admin
     *  approves, the group auto-appears via inbound-message discovery. */
    pendingApprovals: z.array(z.object({ link: z.string() })),
    failures: z.array(z.object({
        link: z.string(),
        reason: z.string(),
    })),
});
export const UpdateGroupRequest = z.object({
    title: z.string().min(1).max(256).optional(),
    judgeSampleRate: z.number().min(0).max(1).optional(),
});
export const GroupStats = z.object({
    groupId: z.string().uuid(),
    msgCount24h: z.number().int(),
    msgCountTotal: z.number().int(),
    leadCountTotal: z.number().int(),
    lastMessageAt: z.string().datetime().nullable(),
});
export const GroupStatsResponse = z.object({
    items: z.array(GroupStats),
});
export const LeaveGroupRequest = z.object({
    /**
     * Account to issue the leave RPC. Defaults to the joinedByAccountId on the
     * group row; explicit override lets admin leave via a different owned account
     * (e.g. when the original joiner got banned).
     */
    byAccountId: z.string().uuid().optional(),
});
//# sourceMappingURL=group.js.map